import {AssessmentTokenService} from '../../shared/services/assessment-token.service';
import {Role} from '../../shared/models/role';
import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Assessment } from '../../shared/models/assessment';
import { AssessmentService } from '../../shared/services/assessment.service';
import {DacConfig} from "../../shared/services/dac-config.service";
import { AuthService } from 'app/login/services/auth.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-assessment-list',
  templateUrl: './assessment-list.component.html',
  styleUrls: ['./assessment-list.component.css']
})
export class AssessmentListComponent implements OnInit,OnDestroy {

  private _assessments:Assessment[]
  private _userRole:Role;
  private _userSubscription:ISubscription;
  public hasLoadedAssessments:boolean;

  constructor(
    private _assessmentService:AssessmentService
    ,private alertService:AlertService
    ,private dacConfig:DacConfig
    ,private authService:AuthService
    ,private assessmentTokenService:AssessmentTokenService
  ) { 
    this._assessments = [];
    this.hasLoadedAssessments = false;
    this._userRole = Role.UnAuthenticated;
    this._userSubscription = this.authService.getLoginState().subscribe(loginState => {
      if (loginState.user) {
        this._userRole = loginState.user.role;
      }
      else {
        this._userRole = Role.UnAuthenticated;
      }
    });
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }

  get Assessments() {
    return this._assessments;
  }

  get canManageAssessments() {
    return this.dacConfig.isFeatureEnabled("assessments.manage");
  }

  public canEdit(assessment:Assessment) {
   
    if (this._userRole == Role.SuperUser) {
      return true;
    }
    else if (this._userRole == Role.Admin) {
      return !assessment.isPublic;
    }
    
    return false;
  }

  public getTokens(assessment:Assessment) {
    return this.assessmentTokenService.getRemainingTokens(assessment);
  }

  public get tokensEnabled() {
    return this.assessmentTokenService.isTokensEnabled();
  }

  ngOnInit() {
    
    Promise.all(
      [
        this._assessmentService.getAssessmentList()
        ,this.assessmentTokenService.loadAssessmentTokens()
      ]
    )
    .then((results) => {
      let [assessmentList,] = results;
      this._assessments = assessmentList;
      this.hasLoadedAssessments = true;
    })
    .catch((error) => {
      this.alertService.error("Failed to load assessments from server");
      console.error(error);
      this.hasLoadedAssessments = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-list/assessment-list.component.ts